import {
  gridSize,
  gridSizeConst10,
  gridSizeConst2,
  gridSizeMdLg1,
  gridSizeMdLg3,
  gridSizeMdLg5,
  gridSizeMdLg6,
  parentescoMockupData,
  servicioCorreoData,
  texto,
  TipoContribuyenteRucChoice,
  TipoIdentificacionEnumChoice,
} from "@/shared";
import {
  CustomAutocomplete,
  CustomAutocompleteArrString,
  CustomTextField,
  CustomTextFieldNoForm,
  CustomTextFieldNumberComponente,
  TabTextLabel,
} from "@/shared/components/ui";
import { TiposTextFieldNumberEnum } from "@/shared/components/ui/CustomTextFieldNumberComponente";
import { IDataProspecto, IFormPreventa } from "@/shared/interfaces";
import SearchIcon from "@mui/icons-material/Search";
import { Grid, IconButton, Typography } from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import { emailENUM, TooltipIconEdit } from "../SavePreventa";

interface TabInformacionPersonalProps {
  dataProspecto: IDataProspecto;
  editSupervisor: boolean;
  form: UseFormReturn<IFormPreventa, any, IFormPreventa>;
  handleBuscarRepresententeLegal: () => Promise<void>;
  valorRestriccionCel?: any;
}

export default function TabInformacionPersonalPreventa({
  dataProspecto,
  editSupervisor,
  form,
  handleBuscarRepresententeLegal,
  valorRestriccionCel
}: TabInformacionPersonalProps) {
  const {
    control,
    reset,
    formState: { errors },
  } = form;

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <TabTextLabel
          text={texto.informacion_personal}
          mt={0}
          pb={2}
          pl={0}
          pt={2}
        />
      </Grid>

      <CustomTextFieldNoForm
        disabled={true}
        label={texto.tipo_documento}
        defaultValue={dataProspecto?.tipo_identificacion}
        value={dataProspecto?.tipo_identificacion}
        size={gridSizeMdLg6}
      />

      <CustomTextFieldNoForm
        disabled={true}
        label={texto.identificacion}
        defaultValue={dataProspecto?.identificacion}
        value={dataProspecto?.identificacion}
        size={gridSizeMdLg6}
      />

      <CustomTextFieldNoForm
        disabled={true}
        label={texto.nombre}
        defaultValue={dataProspecto?.razon_social}
        value={dataProspecto?.razon_social}
        size={gridSize}
      />

      {dataProspecto.tipo_identificacion ==
        TipoIdentificacionEnumChoice.RUC && (
        <>
          <CustomTextFieldNoForm
            disabled={true}
            label={texto.regimen}
            defaultValue={dataProspecto?.regimen}
            value={dataProspecto?.regimen}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.tipo_contribuyente}
            defaultValue={dataProspecto?.tipo_contribuyente}
            value={dataProspecto?.tipo_contribuyente}
            size={gridSizeMdLg6}
          />
        </>
      )}

      {dataProspecto?.tipo_identificacion !=
        TipoIdentificacionEnumChoice.RUC && (
        <>
          <CustomTextFieldNoForm
            disabled={true}
            label={texto.fecha_nacimiento}
            defaultValue={dataProspecto?.fecha_nacimiento}
            value={dataProspecto?.fecha_nacimiento}
            size={gridSizeMdLg3}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.edad}
            defaultValue={dataProspecto?.edad}
            value={dataProspecto?.edad}
            size={gridSizeMdLg3}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={`Tercera edad`}
            defaultValue={form.getValues().es_tercera_edad ? "SI" : "NO"}
            value={form.getValues().es_tercera_edad ? "SI" : "NO"}
            size={gridSizeMdLg3}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={`Tutor/Curador`}
            defaultValue={dataProspecto?.es_curador_tutor ? "SI" : "NO"}
            value={dataProspecto?.es_curador_tutor ? "SI" : "NO"}
            size={gridSizeMdLg3}
          />
        </>
      )}

      <CustomTextFieldNoForm
        disabled={true}
        label={`Linea`}
        defaultValue={`Linea ${dataProspecto.linea!}`}
        value={`Linea ${dataProspecto.linea!}`}
        size={gridSizeMdLg3}
      />

      <CustomTextFieldNoForm
        disabled={true}
        label={`Bono desarrollo humano`}
        defaultValue={dataProspecto.es_bono_humano ? "SI" : "NO"}
        value={dataProspecto.es_bono_humano ? "SI" : "NO"}
        size={gridSizeMdLg3}
      />

      <CustomTextFieldNoForm
        disabled={true}
        label={`Discapacitado`}
        defaultValue={form.getValues().es_discapacitado ? "SI" : "NO"}
        value={form.getValues().es_discapacitado ? "SI" : "NO"}
        size={gridSizeMdLg3}
      />

      <CustomTextFieldNoForm
        disabled={true}
        label={`Ayuda social`}
        defaultValue={dataProspecto.es_ayuda_social ? "SI" : "NO"}
        value={dataProspecto.es_ayuda_social ? "SI" : "NO"}
        size={gridSizeMdLg3}
      />

      <CustomTextFieldNoForm
        disabled={true}
        label={`Aplica Gremio`}
        defaultValue={dataProspecto.es_gremio ? "SI" : "NO"}
        value={dataProspecto.es_gremio ? "SI" : "NO"}
        size={gridSizeMdLg3}
      />

      <Grid item xs={12} container spacing={3}>
        <CustomTextFieldNumberComponente
          size={gridSizeMdLg6}
          endAdornmentInput={editSupervisor ? <TooltipIconEdit /> : null}
          type={TiposTextFieldNumberEnum.CELULAR}
          label={"Celular Adicional"}
          error={errors.celular_2}
          helperText={errors.celular_2?.message}
          control={form.control}
          name="celular_2"
          defaultValue={form.getValues().celular_2 || ""}
          customRestriccionCelular={valorRestriccionCel}
          soloAdvertenciaRestriccion={true}
        />
      </Grid>

      <CustomTextField
        endAdornmentInput={editSupervisor ? <TooltipIconEdit /> : null}
        name="email_temporal"
        type="lower"
        label={texto.email}
        control={form.control}
        defaultValue={form.getValues().email_temporal || ""}
        error={errors.email_temporal}
        helperText={errors.email_temporal?.message ?? ""}
        size={gridSizeMdLg6}
        onChangeValue={(value) => {
          if (form.getValues().servicio_correo == emailENUM.MANUALMENTE)
            return reset({ ...form.getValues(), email_temporal: value });

          reset({
            ...form.getValues(),
            email_temporal: value.replace(/[@\s]/g, ""),
          });
        }}
      />

      <CustomAutocompleteArrString
        endAdornmentInput={editSupervisor ? <TooltipIconEdit /> : null}
        label="Servicio de correo"
        name="servicio_correo"
        options={servicioCorreoData}
        control={form.control}
        defaultValue={form.getValues().servicio_correo}
        error={errors.servicio_correo}
        helperText={errors.servicio_correo?.message?.toString() ?? ""}
        isLoadingData={false}
        size={gridSizeMdLg6}
        onChangeValue={(value) => {
          if (form.getValues().email_temporal && value == emailENUM.MANUALMENTE)
            return reset({
              ...form.getValues(),
              servicio_correo: value,
              email_temporal: "",
            });
        }}
      />

      <Grid item xs={12}>
        <Typography
          variant="subtitle2"
          style={{
            color: "#6C737F",
          }}
        >
          {texto.nota_correo_valido}
        </Typography>
      </Grid>

      {/* {editSupervisor && (
        <>
          <SampleCheckbox
            label="Persona de Tercera edad"
            name="es_tercera_edad"
            control={form.control}
            defaultValue={!!form.getValues().es_tercera_edad}
            size={gridSizeMdLg6}
          />

          <SampleCheckbox
            label="¿Tiene Discapacidad?"
            name="es_discapacitado"
            control={form.control}
            defaultValue={!!form.getValues().es_discapacitado}
            size={gridSizeMdLg6}
          />
        </>
      )} */}

      {dataProspecto.tipo_identificacion == TipoIdentificacionEnumChoice.RUC &&
        dataProspecto.tipo_contribuyente ==
          TipoContribuyenteRucChoice.SOCIEDAD && (
          <>
            <Grid item xs={12}>
              <TabTextLabel
                text={"Representante Legal"}
                mt={0}
                pb={2}
                pl={0}
                pt={2}
              />
            </Grid>

            <CustomAutocompleteArrString
              size={gridSizeMdLg6}
              label={texto.tipo_documento}
              name="representante_legal_tipo_identificacion"
              options={[TipoIdentificacionEnumChoice.CEDULA]}
              defaultValue={
                form.getValues().representante_legal_tipo_identificacion ?? ""
              }
              isLoadingData={false}
              control={control}
              error={errors.representante_legal_tipo_identificacion}
              helperText={
                errors.representante_legal_tipo_identificacion?.message
              }
            />

            <Grid
              item
              container
              {...gridSizeMdLg6}
              spacing={3}
              alignItems={"center"}
            >
              <CustomTextFieldNumberComponente
                size={gridSizeConst10}
                max={10}
                type={TiposTextFieldNumberEnum.IDENTIFICACION}
                label={texto.identificacion}
                error={errors.representante_legal_identificacion}
                helperText={errors.representante_legal_identificacion?.message}
                control={control}
                name="representante_legal_identificacion"
                defaultValue={""}
                onChangeValue={(e) => {
                  if (e.length == 10 || e.length == 13) {
                    handleBuscarRepresententeLegal();
                  } else {
                    form.setValue("representante_legal_razon_social", "");
                  }
                }}
              />

              <Grid item {...gridSizeConst2}>
                <IconButton
                  onClick={() => {
                    handleBuscarRepresententeLegal();
                  }}
                  size="small"
                >
                  <SearchIcon />
                </IconButton>
              </Grid>
            </Grid>

            <CustomTextField
              disabled
              endAdornmentInput={editSupervisor ? <TooltipIconEdit /> : null}
              type="texto_sin_numeros"
              control={form.control}
              name="representante_legal_razon_social"
              label={"Razon Social del Representante Legal"}
              error={errors.representante_legal_razon_social}
              defaultValue={
                form.getValues().representante_legal_razon_social || ""
              }
              helperText={errors.representante_legal_razon_social?.message}
            />
          </>
        )}

      <Grid item xs={12}>
        <TabTextLabel
          text={texto.informacion_referencia}
          mt={0}
          pb={2}
          pl={0}
          pt={2}
        />
      </Grid>

      <CustomTextField
        endAdornmentInput={editSupervisor ? <TooltipIconEdit /> : null}
        type="texto_sin_numeros"
        control={form.control}
        name="persona_referencia_nombre"
        label={texto.persona_referencia}
        error={errors.persona_referencia_nombre}
        defaultValue={form.getValues().persona_referencia_nombre || ""}
        helperText={errors.persona_referencia_nombre?.message}
      />

      <CustomAutocomplete<any>
        size={editSupervisor ? gridSizeMdLg5 : gridSizeMdLg6}
        label={texto.tipo_parentesco}
        name="persona_referencia_parentesco"
        options={parentescoMockupData || []}
        valueKey="nombre" // name is the fk
        defaultValue={form.getValues().persona_referencia_parentesco || ""}
        isLoadingData={false}
        control={control}
        error={errors.persona_referencia_parentesco}
        helperText={errors.persona_referencia_parentesco?.message}
      />

      {editSupervisor && (
        <Grid
          item
          {...gridSizeMdLg1}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <TooltipIconEdit />
        </Grid>
      )}

      <CustomTextFieldNumberComponente
        endAdornmentInput={editSupervisor ? <TooltipIconEdit /> : null}
        size={gridSizeMdLg6}
        type={TiposTextFieldNumberEnum.CELULAR}
        label={texto.celular_referencia}
        error={errors.persona_referencia_celular}
        helperText={errors.persona_referencia_celular?.message}
        control={form.control}
        defaultValue={form.getValues().persona_referencia_celular || ""}
        name="persona_referencia_celular"
        customRestriccionCelular={valorRestriccionCel}
        soloAdvertenciaRestriccion={true}
      />

      <CustomTextFieldNumberComponente
        endAdornmentInput={editSupervisor ? <TooltipIconEdit /> : null}
        required={false}
        size={gridSizeMdLg6}
        type={TiposTextFieldNumberEnum.TELEFONO}
        label={texto.telefono_fijo_referencia} //TELEFONO ADICIONAL REFERENCIA
        error={errors.persona_referencia_celular_2}
        helperText={errors.persona_referencia_celular_2?.message}
        control={form.control}
        defaultValue={form.getValues().persona_referencia_celular_2}
        name="persona_referencia_celular_2"
        customRestriccionCelular={valorRestriccionCel}
        max={9}
      />
    </Grid>
  );
}
